import hiddenRoute from '@/router/hiddenRoute';

const constantRoutes = [
    {
        path: 'redirect',
        name: 'redirect',
        component: () => import('@/layout'),
        hidden: true,
        meta: {
            showRealm: ['COMMON']
        },
        children: [
            {
                name: 'toredirect',
                path: 'redirect/:name(.*)',
                component: () => import('@/views/redirect/index')
            }
        ]
    },
    {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/layout'),
        redirect: { name: 'dashboardPage' },
        meta: {
            showRealm: ['COMMON'],
            icon: 'HSIconfont hs-icon-home',
            code: 'dashboard',
        },
        children: [
            {
                path: 'dashboardPage',
                name: 'dashboardPage',
                component: () => import('@/views/dashboard/index'),
                meta: {
                    code: 'dashboard',
                    icon: 'HSIconfont hs-icon-home',
                    focusIcon: 'HSIconfont hs-icon-home-f',
                    activeMenu: 'dashboard',
                    // focusIcon: 'dashboard_active',
                    breadcrumb: false,
                    affix: true,
                    onlyShowSelf: true
                }
            }
        ]
    },
    {
        path: 'static',
        name: 'static',
        component: () => import('@/layout'),
        hidden: true,
        redirect: { name: 'about' },
        meta: {
            showRealm: ['COMMON']
        },
        children: [
            {
                name: 'about',
                path: 'about',
                component: () => import('@/views/about/index')
            },
            {
                name: 'changePassword',
                path: 'changePassword',
                component: () => import('@/views/changePassword/index')
            },
            {
                path: 'userCenter',
                name: 'userCenter',
                component: () => import('@/views/userCenter/index.vue'),

            }
        ]
    },
    {
        path: 'fullScreen/monitorchart',
        name: 'monitorchart',
        component: () => import('@/views/newWindow/monitorchart'),
        hidden: true,
        meta: {
            showRealm: ['COMMON']
        },
    },
    {
        path: 'fullScreen/monitortable',
        name: 'monitortable',
        component: () => import('@/views/newWindow/monitortable'),
        hidden: true,
        meta: {
            showRealm: ['COMMON']
        },
    },
    // {
    //     path: 'pdf',
    //     name: 'pdf',
    //     component: () => import('@/views/newWindow/pdf'),
    //     hidden: true,
    //     meta: {
    //         showRealm: ['COMMON']
    //     },
    // },
    {
        path: 'fullScreen/modifyPassword',
        name: 'modifyPassword',
        component: () => import('@/views/modifyPassword'),
        hidden: true,
        meta: {
            showRealm: ['COMMON']
        },
    },
    {
        path: 'fullScreen/mfa',
        name: 'mfa',
        component: () => import('@/views/mfa'),
        hidden: true,
        meta: {
            showRealm: ['COMMON']
        },
    },
    {
        path: 'fullScreen/redirect/toPlugin',
        name: 'toPlugin',
        component: () => import('@/views/toPlugin'),
        hidden: true,
        meta: {
            showRealm: ['COMMON']
        },
    },
    ...hiddenRoute
];

const defaultLogin = [
    {
        name: 'login',
        path: 'login',
        hidden: true,
        component: () => import("@/views/login/index")
    },
];

const signStaticRouter = [
    {
        name: 'login',
        path: 'login',
        component: () => import("@/views/unitaryLogin/index")
    },
];

let exportStatic = constantRoutes;

if (window.HS_CONST.SIGN_TYPE || window.HS_CONST.SPECIAL_SIGNIN) {
    exportStatic = [...signStaticRouter, ...exportStatic];
} else {
    exportStatic = [...defaultLogin, ...exportStatic];
}

export default exportStatic;